import { useLogger } from '@packages/shared/core/common/hooks';
import { QuizScreenProps, StepTypes } from '@packages/shared/core/quiz/entities';
import SplitStep from '@packages/shared/core/common/components/QuizSteps/SplitStep';
import SignUpScreen from '@packages/shared/core/common/components/QuizScreens/SignUpScreen';
import PasswordScreen from '@packages/shared/core/common/components/QuizScreens/PasswordScreen';
import SignInScreen from '@packages/shared/core/common/components/QuizScreens/SignInScreen';
import EmailConsentScreen from '@packages/shared/core/common/components/QuizScreens/EmailConsentScreen';
import PhoneNumberScreen from '@packages/shared/core/common/components/QuizScreens/PhoneNumberScreen';
import OfferScreen from '@packages/shared/core/common/components/QuizScreens/OfferScreen';
import ChatScreen from '@packages/shared/core/common/components/QuizScreens/ChatScreen';
import ProcessingScreen from '../screens/ProcessingScreen';
import ExpertsCatalogueScreen from '../screens/ExpersCatalogueScreen';
import TypeOfReadingScreen from '../screens/TypeOfReadingScreen';
import TopicToDiscussScreen from '../screens/TopicToDiscussScreen';
import DateScreen from '../screens/DateScreen';
import SingleAnswerScreen from '../screens/SingleAnswerScreen';

const SimpleSimpleRegistrationQuizScreen = (stepData: QuizScreenProps) => {
  const logger = useLogger();

  const { screenType } = stepData;

  switch (screenType) {
    case StepTypes.CHAT:
      return <ChatScreen {...stepData} />;
    case StepTypes.DATE:
      return <DateScreen {...stepData} />;
    case StepTypes.SPLIT:
      return <SplitStep />;
    case StepTypes.TOPIC_TO_DISCUSS:
      return <TopicToDiscussScreen {...stepData} />;
    case StepTypes.TYPE_OF_READING:
      return <TypeOfReadingScreen {...stepData} />;
    case StepTypes.EXPERTS_CATALOGUE:
      return <ExpertsCatalogueScreen {...stepData} />;
    case StepTypes.SIGN_UP:
      return <SignUpScreen {...stepData} />;
    case StepTypes.PASSWORD:
      return <PasswordScreen {...stepData} />;
    case StepTypes.SIGN_IN:
      return <SignInScreen {...stepData} />;
    case StepTypes.EMAIL_CONSENT:
    case StepTypes.EMAIL_CONSENT_WITH_REDIRECT:
      return <EmailConsentScreen {...stepData} />;
    case StepTypes.PHONE_NUMBER:
    case StepTypes.PHONE_NUMBER_WITH_REDIRECT:
      return <PhoneNumberScreen {...stepData} />;
    case StepTypes.PROCESSING:
      return <ProcessingScreen {...stepData} />;
    case StepTypes.OFFER:
      return <OfferScreen {...stepData} />;
    case StepTypes.SINGLE_ANSWER:
      return <SingleAnswerScreen {...stepData} />;
    default: {
      logger.error(new TypeError(`Unknown step data: ${JSON.stringify(stepData)}`));
      return null;
    }
  }
};

export default SimpleSimpleRegistrationQuizScreen;
